import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { carouselVisible } from '../modules/actions';
import { CarouselVisibleImpression } from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [carouselVisible.type]: () => {
    sendGAEvent<CarouselVisibleImpression>({
      event: 'custom_event',
      event_category: 'Related Category',
      event_action: 'Impression',
      event_label: 'not set',
    });
  },
};
